"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationForm = exports.ErrorContainer = exports.InputContainer = exports.InputField = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const error_icon_svg_1 = __importDefault(require("@/assets/error-icon.svg"));
const componentlibrary_1 = require("@emarketer/componentlibrary");
// User $ to easily identiy it against component properties
exports.InputField = styled_components_1.default.input `
  display: flex;
  padding: 8px 24px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  border-radius: 48px;
  border: 1px solid ${({ $isError }) => ($isError ? componentlibrary_1.COLOR.II.RED.DEFAULT : componentlibrary_1.COLOR.II.GRAY.GRAY200)};

  color: ${componentlibrary_1.COLOR.II.BLACK};
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 28.8px; /* 180% */

  background: ${componentlibrary_1.COLOR.II.WHITE} ${({ $isError }) => ($isError ? `url(${error_icon_svg_1.default}) no-repeat right 24px center` : ``)};

  ::placeholder {
    color: ${componentlibrary_1.COLOR.II.GRAY.DARK};
  }
`;
exports.InputContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding-bottom: 24px;
`;
exports.ErrorContainer = styled_components_1.default.div `
  color: ${componentlibrary_1.COLOR.II.RED.DEFAULT};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  padding-top: 8px;
  padding-left: 24px;
`;
exports.RegistrationForm = styled_components_1.default.form `
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
